import React from 'react';
import { Spinner } from '@odin-labs/components';

export function JobsiteScheduleLoading(): React.ReactElement {
  return (
    <div className="odin-h-96 odin-flex odin-items-center odin-justify-center">
      <Spinner size="base" className="odin-text-odin-primary" />
    </div>
  );
}
